import React from 'react'
import type { Editor } from '@tiptap/core'
import { useEditorState } from '@tiptap/react'
import { menuBarStateSelector } from './menuBarState'
import {
    Bold,
    Code,
    CornerDownLeft,
    Italic,
    List,
    ListOrdered, Minus,
    Quote,
    Redo2,
    Strikethrough,
    Undo2
} from "lucide-react";
import "../../../styles/component/menu-bar.scss"

export const MenuBar = ({editor}: { editor: Editor | null }) => {

    const editorState = useEditorState({
        editor,
        selector: menuBarStateSelector,
    })


    if (!editor || !editorState) {
        return null
    }

    const headingValue = editorState.isHeading1 ? 'h1' : editorState.isHeading2 ? 'h2'
        : editorState.isHeading3 ? 'h3' : editorState.isHeading4 ? 'h4'
            : editorState.isHeading5 ? 'h5' : editorState.isHeading6 ? 'h6' : 'paragraph';

    return (
        <div className="menu-bar">
            <div className="menu-bar__group">
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    disabled={!editorState.canBold}
                    className={editorState.isBold ? 'is-active' : ''}
                >
                    <Bold/>
                </button>
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    disabled={!editorState.canItalic}
                    className={editorState.isItalic ? 'is-active' : ''}
                >
                    <Italic/>
                </button>
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleStrike().run()}
                    disabled={!editorState.canStrike}
                    className={editorState.isStrike ? 'is-active' : ''}
                >
                    <Strikethrough/>
                </button>
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleCode().run()}
                    disabled={!editorState.canCode}
                    className={editorState.isCode ? 'is-active' : ''}
                >
                    <Code/>

                </button>

                <select
                    value={headingValue}
                    onChange={(e) => {
                        const value = e.target.value

                        if (value === 'paragraph') {
                            editor.chain().focus().setParagraph().run()
                            return
                        }

                        editor
                            .chain()
                            .focus()
                            .toggleHeading({
                                level: Number(value.replace('h', '')) as 1 | 2 | 3 | 4 | 5 | 6,
                            })
                            .run()
                    }}
                >
                    <option
                        value='paragraph'
                        className={editorState.isParagraph ? 'is-active' : ''}
                    >
                        Paragraph
                    </option>
                    <option
                        value="h1"
                        className={editorState.isHeading1 ? 'is-active' : ''}
                    >
                        H1
                    </option>
                    <option
                        value="h2"
                        className={editorState.isHeading2 ? 'is-active' : ''}
                    >
                        H2
                    </option>
                    <option
                        value="h3"
                        className={editorState.isHeading3 ? 'is-active' : ''}
                    >
                        H3
                    </option>
                    <option
                        value="h4"
                        className={editorState.isHeading4 ? 'is-active' : ''}
                    >
                        H4
                    </option>
                    <option
                        value="h5"
                        className={editorState.isHeading5 ? 'is-active' : ''}
                    >
                        H5
                    </option>
                    <option
                        value="h6"
                        className={editorState.isHeading6 ? 'is-active' : ''}
                    >
                        H6
                    </option>
                </select>


                <div className="menu-bar__group">
                    <button
                        type="button"
                        className={editorState.isBulletList ? 'is-active' : ''}
                        onClick={() => editor.chain().focus().toggleBulletList().run()}
                    >
                        <List/>
                    </button>

                    <button
                        type="button"
                        className={editorState.isOrderedList ? 'is-active' : ''}
                        onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    >
                        <ListOrdered/>
                    </button>

                    <button
                        type="button"
                        className={editorState.isBlockquote ? 'is-active' : ''}
                        onClick={() => editor.chain().focus().toggleBlockquote().run()}
                    >
                        <Quote/>
                    </button>
                </div>

                <button    type="button"  onClick={() => editor.chain().focus().setHorizontalRule().run()}>
                    <Minus/>
                </button>
                <button    type="button" onClick={() => editor.chain().focus().setHardBreak().run()}>
                    <CornerDownLeft/>
                </button>

                <div className="menu-bar__group">
                    <button
                        type="button"
                        onClick={() => editor.chain().focus().undo().run()}
                        disabled={!editorState.canUndo}
                    >
                        <Undo2/>
                    </button>
                    <button
                        type="button"
                        onClick={() => editor.chain().focus().redo().run()}
                        disabled={!editorState.canRedo}
                    >
                        <Redo2/>
                    </button>
                </div>
            </div>
        </div>
    )
}
